module.exports = __webpack_public_path__ + "static/img/SIPB-BYTSGiYY.e064743.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/SIPB-BYTSGiYY.png
// module id = k/3c
// module chunks = 16